/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Notification Verified Icon component.
 */
export const NotificationVerifiedIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 54 54' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M27 0C12.1074 0 0 12.1074 0 27C0 41.8926 12.1074 54 27 54C41.8926 54 54 41.8926 54 27C54 12.1074 41.8926 0 27 0ZM27 50.7031C13.9263 50.7031 3.29684 40.0737 3.29684 27C3.29684 13.9263 13.9263 3.29684 27 3.29684C40.0737 3.29684 50.7032 13.9263 50.7032 27C50.7032 40.0737 40.0737 50.7031 27 50.7031Z' fill={iconColor} />
      <path d='M39.5055 18.4738L23.5329 34.4464L15.4045 26.318C14.6087 25.5222 13.3013 25.5222 12.5055 26.318C11.7097 27.1138 11.7097 28.4212 12.5055 29.217L22.055 38.7664C22.4529 39.1643 22.9645 39.3917 23.5329 39.3917C24.1013 39.3917 24.6129 39.1643 25.0108 38.7664L42.4045 21.3727C43.2003 20.5769 43.2003 19.2696 42.4045 18.4738C41.6087 17.678 40.3582 17.678 39.5055 18.4738Z' fill={iconColor} />
    </svg>
  );
};

export default NotificationVerifiedIcon;
